import { browserOnly } from './browserOnly';

/** Returns true if the user is in standalone display mode. */
export function isStandaloneDisplayMode() {
  return browserOnly(
    window => window.matchMedia('(display-mode: standalone)').matches,
    () => false
  );
}
